module.exports = __webpack_public_path__ + "img/weather13.55a1b4fa.png";